import { makeAutoObservable } from 'mobx';

import { BotError } from '../model/boterror/BotError';
import { SplashingBot } from '../model/boterror/SplashingBot';
import { ChatMessage } from '../model/chat/ChatMessage';
import { LogsResponse } from '../model/LogsResponse';
import { deepCopy, deepMapCopy } from '../utils/common.utils';
import botErrorStore from './BotErrorStore';
import chatStore from './ChatStore';
import eventLogsStore from './EventLogsStore';
import gameStore from './GameStore';
import playerActionStore from './PlayerActionStore';
import { GameState } from './state/GameState';
import { GameTable } from './state/GameTable';
import { StateStore } from './StateStore';
import tableStore from './TableStore';

interface IStoresStorage {
  //botErrorStore
  botErrors: Map<string, BotError[]>; //key - tableId
  splashingBots: SplashingBot[];

  //chatStore
  chatMessages: Map<string, ChatMessage[]>;

  //gameStore
  activeGame: GameState;

  //tableStore
  activeTable: GameTable;

  //eventLogsStore
  openedLogs: LogsResponse[];
}

class TableHistoryGameStateStore implements StateStore {
  private stores: IStoresStorage[] = [];

  public constructor() {
    makeAutoObservable(this);
  }

  public resetState = (): void => {
    this.stores = [];
  };

  public captureHolders = (): void => {
    const state = {
      botErrors: deepMapCopy(botErrorStore.getAllBotErrors()),
      splashingBots: deepCopy(botErrorStore.getAllSplashingBots()),
      chatMessages: deepMapCopy(chatStore.getAllChatMessages()),
      openedLogs: deepCopy(eventLogsStore.getAllOpenedLogs()),
      activeGame: this.copyActiveGame(),
      activeTable: this.copyActiveTable(),
    };
    this.stores.push(state);
  };

  public stepBackward = (): void => {
    this.restoreState();
    gameStore.forceReloadGame();
  };

  private restoreState = (): void => {
    const state = this.stores.pop();
    state.activeGame.setTurnStartingTime(new Date());
    state.activeGame.setTable(state.activeTable);

    botErrorStore.setBotErrors(state.botErrors);
    botErrorStore.setSplashingBots(state.splashingBots);
    chatStore.setChatMessages(state.chatMessages);
    tableStore.setTables([state.activeTable]);
    gameStore.setActiveGames([state.activeGame]);
    playerActionStore.clearAllPlayerActions();
    eventLogsStore.setOpenedLogs(state.openedLogs);
  };

  private copyActiveGame = (): GameState => {
    const newGame = new GameState();
    newGame.copyGame(deepCopy(gameStore.activeGames.values().next().value));
    return newGame;
  };

  private copyActiveTable = (): GameTable => {
    const newTable = new GameTable();
    newTable.copyTable(deepCopy(tableStore.activeTables.values().next().value));
    return newTable;
  };
}

const stateHolder = new TableHistoryGameStateStore();
export default stateHolder;
